!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/a11y"] = t() : (e.wp = e.wp || {}, e.wp.a11y = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      615: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function addContainer() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "polite";
          var t = document.createElement("div");
          t.id = "a11y-speak-".concat(e), t.className = "a11y-speak-region", t.setAttribute("style", "position: absolute;margin: -1px;padding: 0;height: 1px;width: 1px;overflow: hidden;clip: rect(1px, 1px, 1px, 1px);-webkit-clip-path: inset(50%);clip-path: inset(50%);border: 0;word-wrap: normal !important;"), t.setAttribute("aria-live", e), t.setAttribute("aria-relevant", "additions text"), t.setAttribute("aria-atomic", "true");
          var _document = document,
              r = _document.body;
          r && r.appendChild(t);
          return t;
        };
      },
      227: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function addIntroText() {
          var e = document.createElement("p");
          e.id = "a11y-speak-intro-text", e.className = "a11y-speak-intro-text", e.textContent = (0, n.__)("Notifications"), e.setAttribute("style", "position: absolute;margin: -1px;padding: 0;height: 1px;width: 1px;overflow: hidden;clip: rect(1px, 1px, 1px, 1px);-webkit-clip-path: inset(50%);clip-path: inset(50%);border: 0;word-wrap: normal !important;"), e.setAttribute("hidden", "hidden");
          var _document2 = document,
              t = _document2.body;
          t && t.appendChild(e);
          return e;
        };
        var n = r(756);
      },
      91: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function clear() {
          var e = document.getElementsByClassName("a11y-speak-region"),
              t = document.getElementById("a11y-speak-intro-text");

          for (var _t = 0; _t < e.length; _t++) {
            e[_t].textContent = "";
          }

          t && t.setAttribute("hidden", "hidden");
        };
      },
      74: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function filterMessage(e) {
          e = e.replace(/<[^<>]+>/g, " "), r === e && (e += " ");
          return r = e, e;
        };
        var r = "";
      },
      46: function _(e) {
        "use strict";

        e.exports = require("@wordpress/dom-ready");
      },
      756: function _(e) {
        "use strict";

        e.exports = require("@wordpress/i18n");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r](i, i.exports, __webpack_require__), i.exports;
    }

    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.setup = setup, e.speak = function speak(e, t) {
        (0, a.default)(), e = (0, s.default)(e);
        var r = document.getElementById("a11y-speak-intro-text"),
            n = document.getElementById("a11y-speak-assertive"),
            i = document.getElementById("a11y-speak-polite");
        n && "assertive" === t ? n.textContent = e : i && (i.textContent = e);
        r && r.removeAttribute("hidden");
      };
      var n = t(__webpack_require__(46)),
          i = t(__webpack_require__(227)),
          o = t(__webpack_require__(615)),
          a = t(__webpack_require__(91)),
          s = t(__webpack_require__(74));

      function setup() {
        var e = document.getElementById("a11y-speak-intro-text"),
            t = document.getElementById("a11y-speak-assertive"),
            r = document.getElementById("a11y-speak-polite");
        null === e && (0, i.default)(), null === t && (0, o.default)("assertive"), null === r && (0, o.default)("polite");
      }

      (0, n.default)(setup);
    }(), r;
  }();
});